import React from 'react';
import { Switch, useLocation } from 'react-router-dom';
import * as config from 'config';

const logo = require('images/merch-cloud-maropost.png');
import styles from './styles.css';

const NotAuthorizedLayout = ({ title, children, ...rest }) => {
  const location = useLocation();

  const isSignInPage = location.pathname.includes('auth/sign-in');
  const shouldRedirectToKc = location?.pathname?.includes('auth=true');

  if (shouldRedirectToKc) {
    window.location.href = config.adminApi.url + '/v1/keycloak/login/1';
    return <></>;
  }

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        {!isSignInPage && (
          <div className={styles.header}>
            <img className={styles.logo} alt="Findify" src={logo} />
            <h3 className={styles.title}>{title}</h3>
          </div>
        )}
        <Switch>{children}</Switch>
      </div>
    </div>
  );
};

export default NotAuthorizedLayout;
